/* eslint-disable no-loop-func */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable new-cap */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
import { format, startOfWeek, endOfWeek, startOfMonth, endOfMonth, startOfQuarter, endOfQuarter, startOfYear, endOfYear, subDays } from 'date-fns'

import React, { useEffect, useState } from 'react'

import Swal from 'sweetalert2'
import html2canvas from 'html2canvas'
import { jsPDF } from 'jspdf'

import { AdvancedCard } from './components/charts/Card/AdvancedCard/index'
import { BarraTitulo } from '../../components/BarraTitulo'
import { api } from '../../services/api'
import Loading from './components/Loanding/index'
import { useParams } from 'react-router-dom'
import FeatherIcon from 'feather-icons-react'

import { useContext } from 'react'
import MyContext from '../../contexts/myContext'

import styles from "./stylesB2B_CotacaoVendas.module.css"


import "../../components/stylesGuia.css"

import { CardStatus } from '../../components/CardStatus'
import { GridProdutosCotacao } from './components/GridProdutosCotacao'
import { GridCotacoes } from './components/GridCotacoes'

export default function B2B_CotacaoVendas(props) {
    const [valoresCotacaoVenda, setValoresCotacaoVenda] = useState([])
    const [valoresCotacaoVendaFiltro, setValoresCotacaoVendaFiltro] = useState([])
    const [isLoading, setisLoading] = useState(false)
    const [filterModeStatusCardCotacao, setFilterModeStatusCardCotacao] = useState(false)
    const [filterCardFechados, setFilterCardFechados] = useState(false)
    const [filterCardNegociacao, setFilterCardNegociacao] = useState(false)
    const [filterCardPerdidos, setFilterCardPerdidos] = useState(false)
    const [filterCardCancelados, setFilterCardCancelados] = useState(false)
    const [filterModeStatusCardVenda, setFilterModeStatusCardVenda] = useState(false)
    const [statusAtual, setStatusAtual] = useState([])
    const [status, setStatus] = useState([])
    const [arrStatus, setArrStatus] = useState([])

    const params = useParams()
    const vNomeAmigavel = params.NomeAmigavel || props.NomeAmigavel

    function encheCombos(dados) {
        if (!dados?.length > 0) {
            return
        }

        const ArrStatus = dados
            ?.reduce((acc, cotacoes, key) => {
                if (key === 0) {
                    acc = [{ value: key, label: cotacoes.Status }]
                } else if (!acc.map(item => {
                    return item.label === cotacoes.Status
                }
                ).includes(true)) {
                    acc = [...acc, { value: acc.length, label: cotacoes.Status }]
                }
                return acc
            }, [])

        setStatus(ArrStatus.sort((a, b) => (a.value > b.value) ? 1 : -1))
        setArrStatus(ArrStatus)

    }


    const { setHidebar, user, hideBar } = useContext(MyContext)

    useEffect(() => {

        if (params?.hideBar === "true") {
            setHidebar(true)
        }

    }, [])

    const timeElapsed = Date.now();
    const today = new Date(timeElapsed);

    function DataFilter() {
        let vDataInicial = window.document.getElementById('dtIniCotacaoVendas').value
        let vDataFinal = window.document.getElementById('dtFimCotacaoVendas').value

        if (vDataInicial.length !== 0 && vDataFinal.length === 0) {
            return Swal.fire({
                icon: 'error',
                title: 'Validação',
                text: 'Preencha a data final!'
            })
        }
        if (vDataInicial.length === 0 && vDataFinal.length !== 0) {
            return Swal.fire({
                icon: 'error',
                title: 'Validação',
                text: 'Preencha a data Inicial!'
            })
        }
        if (vDataInicial > vDataFinal) {
            return Swal.fire({
                icon: 'error',
                title: 'Validação',
                text: 'A data inicial não pode ser maior que a data final!'
            })
        }

        getValoresCotacaoVenda()

    }

    const [stateListaEmpresas, setStateListaEmpresas] = useState([])


    const getValoresCotacaoVenda = async () => {

        clearFiltersMode()
        let vDataInicial = window.document.getElementById('dtIniCotacaoVendas').value
        let vDataFinal = window.document.getElementById('dtFimCotacaoVendas').value
        let vTipoData = "OrcamentoData"



        setisLoading(true)

        const myDadosDash = dadosDash.filter(dash => dash.NomeAmigavel === vNomeAmigavel)

        if (myDadosDash.length > 0) {
            await api
                .get('/B2B_CotacaoVendas/api/valoresDash',
                    {
                        params: {
                            tipoData: vTipoData,
                            dataCadastroInicio: vDataInicial,
                            dataCadastroFim: vDataFinal,
                            idUsuario: user?.idUsuario,
                            respeitarRegrasHierarquia: myDadosDash[0].respeitarRegrasHierarquia
                        }
                    }
                )
                .then(data => {
                    const results = data.data
                    setValoresCotacaoVenda(results)
                    encheCombos(results)
                    setValoresCotacaoVendaFiltro(results)
                })
                .catch(error => console.log(error))

            await api
                .get('/B2B_CotacaoVendas/api/valoresDashDetalhe',
                    {
                        params: {
                            tipoData: vTipoData,
                            dataCadastroInicio: vDataInicial,
                            dataCadastroFim: vDataFinal,
                            idUsuario: user?.idUsuario,
                            respeitarRegrasHierarquia: myDadosDash[0].respeitarRegrasHierarquia
                        }
                    }
                )
                .then(data => {
                    const results = data.data


                    setRegistrosProdutos(results)
                })
                .catch(error => console.log(error))

            await api
                .get('/B2B_CotacaoVendas/api/valoresDashProdutosCotacao',
                    {
                        params: {
                            tipoData: vTipoData,
                            dataCadastroInicio: vDataInicial,
                            dataCadastroFim: vDataFinal,
                            idUsuario: user?.idUsuario,
                            respeitarRegrasHierarquia: myDadosDash[0].respeitarRegrasHierarquia
                        }
                    }
                )
                .then(data => {
                    const results = data.data


                    setRegistrosProdutosCotacao(results)
                })
                .catch(error => console.log(error))
        }

        setisLoading(false)
    }

    const printRefPage = React.useRef()


    const [filterModeCardSemContato, setFilterModeCardSemContato] = useState(false)

    function clearFiltersMode() {
        setFilterModeCardSemContato(false)
        setFilterModeStatusCardCotacao(false)
        setFilterModeStatusCardVenda(false)
        setFilterCardFechados(false)
        setFilterCardNegociacao(false)
        setFilterCardPerdidos(false)
        setFilterCardCancelados(false)

    }


    const handleDownloadPdfPage = async () => {
        const element = printRefPage.current
        const canvas = await html2canvas(element)
        const data = canvas.toDataURL('image/png')

        const pdf = new jsPDF()
        const imgProperties = pdf.getImageProperties(data)
        const pdfWidth = pdf.internal.pageSize.getWidth()
        const pdfHeight =
            1000

        pdf.addImage(data, 'PNG', 0, 0, pdfWidth, pdfHeight)
        pdf.save('B2bCotacoes.pdf')
    }

    function ExportarComponentePage() {
        Swal.fire({
            title: 'Como deseja exportar o Componente?',
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: 'Imagem',
            denyButtonText: 'PDF',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                Swal.fire('Imagem exportada!', '', 'success')
                // Função para imagem
                // exportComponentAsPNG(printRef)
                const { exportComponentAsPNG } = await import('react-component-export-image')
                exportComponentAsPNG(printRefPage)
            } else if (result.isDenied) {
                // Função para PDF
                Swal.fire('PDF exportado!', '', 'success')
                handleDownloadPdfPage()
            }
        })
    }


    function handleSetStatusFiltro(vStatus) {
        setStatusAtual(statusAtual.concat(arrStatus.filter(e => e.label === vStatus)))
    }
    function clearFiltroStatus(vStatus) {
        setStatusAtual(statusAtual.filter(e => e.label !== vStatus))
    }


    useEffect(() => {
        let arrayTotal = valoresCotacaoVenda

        if (filterCardFechados) {
            arrayTotal = arrayTotal.filter(e => e.Status === 'FECHADO')
        }

        if (filterCardNegociacao) {
            arrayTotal = arrayTotal.filter(e => e.Status === 'NEGOCIAÇÃO')
        }

        if (filterCardPerdidos) {
            arrayTotal = arrayTotal.filter(e => e.Status === 'PERDIDO')
        }

        if (filterCardCancelados) {
            arrayTotal = arrayTotal.filter(e => e.Status === 'CANCELADO')
        }

        if (filterModeStatusCardCotacao) {
            arrayTotal = arrayTotal.filter(e => e?.TeveCotacaoAteDataConversao === (likeModeCotaram ? 1 : 0))
        }

        if (filterModeStatusCardVenda) {
            arrayTotal = arrayTotal.filter(e => e?.Convertido === (likeModeConversoes ? 1 : 0))
        }


        if (statusAtual.length > 0) {
            let resultStatusAtual = []
            statusAtual.forEach(element => {
                resultStatusAtual = resultStatusAtual.concat(arrayTotal.filter(e => e.Status === element.label))
            });

            arrayTotal = resultStatusAtual
        }

        setValoresCotacaoVendaFiltro(arrayTotal)



    }, [filterModeStatusCardCotacao, filterModeStatusCardVenda,
        filterModeCardSemContato, statusAtual, filterCardFechados, filterCardNegociacao, filterCardPerdidos, filterCardCancelados
    ])




    const [dadosDash, setDadosDash] = useState([])
    const [minutosTempoAtualizacao, setMinutosTempoAtualizacao] = useState(0)
    const [opPeriodoInicialPesquisa, setOpPeriodoInicialPesquisa] = useState('NÃO ESPECIFICADO')
    const [diasPeriodoInicial, setDiasPeriodoInicial] = useState(0)

    const getDadosDashBoard = async () => {
        await api
            .get('/dashboard/api/listaDashboard')
            .then(data => {
                setDadosDash(data.data)
            })
            .catch(error => console.log(error))
    }

    useEffect(() => {
        getDadosDashBoard()
    }, [])

    useEffect(async () => {
        if (dadosDash.length > 0) {

            const myDadosDash = dadosDash.filter(dash => dash.NomeAmigavel === vNomeAmigavel)
            if (myDadosDash.length > 0) {
                setMinutosTempoAtualizacao(parseInt(myDadosDash[0].minutosTempoAtualizacao))

                const vOpPeriodoInicialPesquisa = myDadosDash[0].opPeriodoInicialPesquisa
                setOpPeriodoInicialPesquisa(vOpPeriodoInicialPesquisa)

                const vDiasPeriodoInicial = parseInt(myDadosDash[0].diasPeriodoInicial)
                setDiasPeriodoInicial(vDiasPeriodoInicial)

                switch (vOpPeriodoInicialPesquisa) {
                    case 'ESPECIFICADO':

                        window.document.getElementById('dtIniCotacaoVendas').value = format(new Date(subDays(today, vDiasPeriodoInicial)), 'yyyy-MM-dd')
                        window.document.getElementById('dtFimCotacaoVendas').value = format(today, 'yyyy-MM-dd')
                        break

                    case 'DIA ATUAL':
                        window.document.getElementById('dtIniCotacaoVendas').value = format(today, 'yyyy-MM-dd')
                        window.document.getElementById('dtFimCotacaoVendas').value = format(today, 'yyyy-MM-dd')
                        break
                    case 'SEMANA ATUAL':
                        window.document.getElementById('dtIniCotacaoVendas').value = format(new Date(startOfWeek(today, { weekStartsOn: 1 })), 'yyyy-MM-dd')
                        window.document.getElementById('dtFimCotacaoVendas').value = format(new Date(endOfWeek(today, { weekStartsOn: 1 })), 'yyyy-MM-dd')
                        break
                    case 'MÊS ATUAL':
                        window.document.getElementById('dtIniCotacaoVendas').value = format(new Date(startOfMonth(today, { weekStartsOn: 1 })), 'yyyy-MM-dd')
                        window.document.getElementById('dtFimCotacaoVendas').value = format(new Date(endOfMonth(today, { weekStartsOn: 1 })), 'yyyy-MM-dd')
                        break
                    case 'TRIMESTRE ATUAL':
                        window.document.getElementById('dtIniCotacaoVendas').value = format(new Date(startOfQuarter(today, { weekStartsOn: 1 })), 'yyyy-MM-dd')
                        window.document.getElementById('dtFimCotacaoVendas').value = format(new Date(endOfQuarter(today, { weekStartsOn: 1 })), 'yyyy-MM-dd')
                        break
                    case 'ANO ATUAL':
                        window.document.getElementById('dtIniCotacaoVendas').value = format(new Date(startOfYear(today, { weekStartsOn: 1 })), 'yyyy-MM-dd')
                        window.document.getElementById('dtFimCotacaoVendas').value = format(new Date(endOfYear(today, { weekStartsOn: 1 })), 'yyyy-MM-dd')
                        break
                    default:
                        //DEFAULT = MÊS ATUAL
                        window.document.getElementById('dtIniCotacaoVendas').value = format(new Date(startOfMonth(today, { weekStartsOn: 1 })), 'yyyy-MM-dd')
                        window.document.getElementById('dtFimCotacaoVendas').value = format(new Date(endOfMonth(today, { weekStartsOn: 1 })), 'yyyy-MM-dd')
                }
                getValoresCotacaoVenda()
            }
        }
    }, [dadosDash])

    useEffect(() => {

        if (parseInt(minutosTempoAtualizacao) > 0) {
            const interval = setInterval(() => {
                getValoresCotacaoVenda()
            }, parseInt(minutosTempoAtualizacao) * 60000);

            return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
        }
    }, [minutosTempoAtualizacao])



    const [likeModeCotaram, setLikeModeCotaram] = useState(true)
    const [likeModeConversoes, setLikeModeConversoes] = useState(true)

    const totalGeral = valoresCotacaoVendaFiltro?.reduce(getTotalGeral, 0) || 0
    function getTotalGeral(total, item) {
        return parseFloat(total) + (parseFloat(item.ValorTotal) || 0.00)
    }

    const tMedio = (totalGeral.toFixed(2) / valoresCotacaoVendaFiltro.length) || 0



    const [RegistrosProdutos, setRegistrosProdutos] = useState([])
    const [RegistrosProdutosCotacao, setRegistrosProdutosCotacao] = useState([])



    const [toggleState, setToggleState] = useState(1);

    const toggleTab = (index) => {
        setToggleState(index);
    };

    return (
        <div className='flex flex-col bg-gray-100 h-full w-full  overflow-x-hidden'>
            {isLoading && <Loading />}
            <BarraTitulo
                Name={vNomeAmigavel}
                showTasks={true}
                new={false}
                search={false}
                save={false}
                clean={false}
                delete={false}
                printer={true}
                ExportarPage={() => ExportarComponentePage()}
            />
            <section ref={printRefPage} className={`flex flex-col overflow-y-scroll overflow-x-hidden ${hideBar ? '!h-fit' : '!h-[70vh]'} pb-4  `}>
                <div className={` flex flex-row  ${styles.containerFiltros} `} >
                    <div className='mt-2 mb-2 px-6'>

                        <div className={`bg-white-100 w-fit  flex flex-row items-center gap-x-2  h-full rounded-md`}>

                            <div className={` ${styles.containerDatas} flex gap-x-2 items-center ml-2 p-4 `}>

                                <div className={` ${styles.containerFiltroDatas}`}>
                                    <div className={` ${styles.divInputDatas} flex flex-row items-center justify-center gap-2 mt-2 `} >
                                        <div className='flex gap-x-2 items-center justify-center'>
                                            <label className='text-sm'>
                                                De:
                                            </label>
                                            <input className='w-36 border-2 border-gray-400 rounded-lg text-sm' id="dtIniCotacaoVendas" type="date" maxLength="10" />
                                        </div>

                                        <div className='flex gap-x-2 items-center justify-center'>
                                            <label className='text-sm'>
                                                Até:
                                            </label>
                                            <input className='w-36 text-sm border-2 border-gray-400 rounded-lg' id="dtFimCotacaoVendas" type="date" maxLength="10" />
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <button onClick={() => { DataFilter() }} id="submit" className='text-white-100 h-full text-center text-base font-bold rounded-r-lg p-2 bg-gradient-to-r from-slate-900 to-slate-700'>
                                <FeatherIcon icon={'search'} />
                            </button>
                        </div>
                    </div>
                </div>

                <div className='mt-1 pb-4 '>
                    <div className="mt-1 pl-6 pr-6  flex flex-col">
                        <div className="mt-2">
                            <div className={styles.divCards}>
                                <AdvancedCard
                                    isPrincipal
                                    showButtonLike={false}
                                    gradientColor={'from-BlueRoyal-100 to-BlueRoyal-200'}
                                    title='Geral'
                                    valorUnitario={Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(totalGeral)}
                                    perc={Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format((totalGeral / totalGeral) * 100)}

                                    tMedio={Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2 }).format(tMedio.toFixed(2))}
                                    value={parseInt(valoresCotacaoVendaFiltro.length, 10).toLocaleString('en-US', { minimumFractionDigits: 0 }).replace(',', '.')}
                                />

                                <div className={styles.divCardsCroll}>
                                    <CardStatus
                                        Registros={valoresCotacaoVendaFiltro}
                                        Status={'FECHADO'}
                                        showButtonLike={false}
                                        statusAtual={statusAtual}
                                        setStatusFiltro={handleSetStatusFiltro}
                                        clearFiltroStatus={clearFiltroStatus}
                                        gradientColor={`bg-gradient-to-r from-greenInn-200 from to-greenInn-100`}
                                        isFiltered={true}
                                        estyloProps={{ width: '20%' }}
                                    />

                                    <CardStatus
                                        Registros={valoresCotacaoVendaFiltro}
                                        Status={'NEGOCIAÇÃO'}
                                        showButtonLike={false}
                                        statusAtual={statusAtual}
                                        setStatusFiltro={handleSetStatusFiltro}
                                        clearFiltroStatus={clearFiltroStatus}
                                        gradientColor={`bg-gradient-to-r from-orangeInn-100 from to-orangeInn-200`}
                                        isFiltered={true}
                                        estyloProps={{ width: '20%' }}
                                    />

                                    <CardStatus
                                        Registros={valoresCotacaoVendaFiltro}
                                        Status={'PERDIDO'}
                                        showButtonLike={false}
                                        statusAtual={statusAtual}
                                        setStatusFiltro={handleSetStatusFiltro}
                                        clearFiltroStatus={clearFiltroStatus}
                                        gradientColor={`bg-gradient-to-r from-red-600 to-red-500`}
                                        isFiltered={true}
                                        estyloProps={{ width: '20%' }}
                                    />

                                    <CardStatus
                                        Registros={valoresCotacaoVendaFiltro}
                                        Status={'CANCELADO'}
                                        showButtonLike={false}
                                        statusAtual={statusAtual}
                                        setStatusFiltro={handleSetStatusFiltro}
                                        clearFiltroStatus={clearFiltroStatus}
                                        gradientColor={`bg-gradient-to-r from-slate-500 to-slate-400`}
                                        isFiltered={true}
                                        estyloProps={{ width: '20%' }}
                                    />

                                </div>
                            </div>

                            <GridCotacoes
                                valoresCotacaoVendaFiltro={valoresCotacaoVendaFiltro}
                                RegistrosProdutos={RegistrosProdutos}
                            />

                        </div>
                    </div>
                </div>


            </section>
        </div>
    )
}
